

import { Component, Vue, Prop, Emit } from "vue-property-decorator"

import cloneDeep from "lodash/cloneDeep"

import VuePerfectScrollbar from "vue-perfect-scrollbar"
import { BModal } from "bootstrap-vue"
import vSelect from "vue-select"

import DataModal from "./DataModal.vue"
import HelpIcon from "@/components/New/Page/PageComponents/HelpIcon.vue"

@Component({
	components: {
		"help-icon": HelpIcon,
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar,
		"data-modal": DataModal
	}
})
export default class DataTable extends Vue {
	$refs!: {
		dataModal: BModal
	}
	@Prop()
	public dataType!: string;

	@Prop({ type: String }) helpText!: string;

	@Prop()
	public dataTypeHeader!: string;

	@Prop()
	public columns!: any[];

	@Prop()
	public items!: any[];

	@Prop({ type: String, default: "xl" })
	public modalSize!: string;

	@Prop({ type: Boolean })
	public isBusy!: boolean;

	@Prop({ type: Boolean, default: false })
	public overrideView!: boolean

	@Prop()
	public createNewItem!: (values: any) => any;

	@Prop()
	public deleteDetails!: (item: any) => any;

	@Prop({ default: true })
	public canCreateItem!: boolean;

	@Prop()
	public canDeleteItem!: (item: any) => boolean;

	@Prop()
	public canConfirmDelete!: (item: any) => boolean;

	@Prop()
	public loadItem!: (item: any) => any;

	@Prop({ default: false })
	public hide!: boolean

	@Prop({ default: true })
	public allowRowClick!: boolean

	@Prop({ default: false })
	public noLocalSorting!: boolean

	@Prop({ default: () => { return (item: any, type: any) => "" } })
	public rowClass!: (item: any, type: any) => string;

	public filter: string = "";

	public async rowClick (item: any) {
		if (!this.allowRowClick) {
			return
		}

		if (item.allowRowClick !== undefined && !item.allowRowClick) {
			return
		}

		if (item.onlyEmitOnRowClick !== undefined && item.onlyEmitOnRowClick) {
			this.$emit("row-opened", item)
			return
		}

		const itemClone = this.loadItem
			? await this.loadItem(item)
			: cloneDeep(item)

		this.$refs.dataModal.open(itemClone)

		this.$emit("row-opened", item)
	}

	public get tableColumns () {
		if (!this.columns) {
			return []
		}

		return this.columns.filter(c => c.inTable !== false)
	}

	private get columnsWithTemplate (): any[] {
		if (!this.columns) { return [] }

		return this.columns.filter(c => c.hasTemplate)
	}

	private get boolColumns (): any[] {
		if (!this.columns) { return [] }

		return this.columns.filter(c => c.dataType === "checkbox" && !c.hasTemplate)
	}

	public createNew (values: any) {
		let newItem = this.createNewItem
			? this.createNewItem(values)
			: {}

		this.$refs.dataModal.open(newItem)
	}

	@Emit("save")
	public saveItem (item: any) {
		return item
	}

	@Emit("delete")
	public deleteItem (item: any) {
		return item
	}

	columnTemplateName (column: any) {
		return "cell(" + column.key + ")"
	}

	@Emit("sortChanged")
	public sortChanged (context: any) {
		return context
	}

	/**
	 * Gets the data type in the correct format for data-cy tags i.e.
	 * - Has all spaces replaced with '-'
	 * - Is all lowercase
	 * @private
	 */
	private get dataCyType () {
		let type = (this.dataTypeHeader ? this.dataTypeHeader : this.dataType)
		type = type.replace(/ /g, "-")
		return type.toLowerCase()
	}

	private get headerTitle () {
		return this.dataTypeHeader ? this.dataTypeHeader : this.dataType + "s"
	}

	// Tables that supply an empty slot show it under the column headers when there is nothing to
	// list. Otherwise the empty table is rendered.
	private get showEmptyState (): boolean {
		return !!this.$scopedSlots.empty && !this.isBusy && (!this.items || this.items.length === 0)
	}
}

